<ckeditor
  placeholder="Enter text here ..."
  *ngIf="editorIsLoaded"
  [editor]="editor"
  class=""
  [formControlName]="controlName"
></ckeditor>
